import axios from '../axios-auth'
import orginal_axios from "axios";

export const cashInHandReportService = {
    getCashInHandReport,
    getAllCashInHandReportList,
    exportCashInHandExcel
}

function getCashInHandReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let url = '/auth/cash-in-hand-report?page=' + page + '&size=' + size + '&sort=' + sortedBy;

    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.date) {
        url += '&date=' + searchParams.date;
    }
    return axios.get(url);
}

function getAllCashInHandReportList(searchParams) {
    let url = '/auth/cash-in-hand-report';
    let params = {};
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.date) {
        params["date"] = searchParams.date;
    }
    return axios.get(url, { params });
}

function exportCashInHandExcel(searchParams) {
    let params = {
    };
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.date) {
        params["date"] = searchParams.date;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/cash-in-hand-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
